import { LocationSrc } from '@/_models/Game';

export const asyncStore: {
  //if there is undefined keys on conditions - they was executed when there was no active pathLock
  //(possible on app start conditions execute before pathLock init)

  currentPathStep?: any;
  vrIsOn?: boolean;
  pathIds?: number[];
  pathSnapshot: Record<string, any>;
  regularActivePath: number | null;

  locksPathTimeline: Record<number, { lockId: number; lockPoint: number }[]>;
  hidePathTimeline: Record<number, any[]>;
  revealPathTimeline: Record<number, any[]>;
  restoreTagsTimeline: Record<number, any[]>;

  pushRestoreTagsTimeline: (pathId: number, tagSid: string) => void;
  pushRevealPathTimeline: (pathId: number, conditions: any[]) => void;
  pushHidePathTimeline: (pathId: number, conditions: any[]) => void;
  pushLockPathTimeline: (pathId: number, lockData: { lockId: number; lockPoint: number }) => void;
} = {
  regularActivePath: null,
  pathSnapshot: {},
  pathIds: [],
  locksPathTimeline: {},
  hidePathTimeline: {},
  revealPathTimeline: {},
  restoreTagsTimeline: {},
  pushRestoreTagsTimeline: (pathId, tagSid) => {
    console.log('bbb pushRestoreTagsTimeline', pathId, tagSid);
    if (!asyncStore.restoreTagsTimeline[pathId]) {
      asyncStore.restoreTagsTimeline[pathId] = [];
    }
    asyncStore.restoreTagsTimeline[pathId].push(tagSid);
  },
  pushRevealPathTimeline: (pathId, conditions) => {
    if (!asyncStore.revealPathTimeline[pathId]) {
      asyncStore.revealPathTimeline[pathId] = [];
    }
    asyncStore.revealPathTimeline[pathId].push(...conditions);
  },
  pushHidePathTimeline: (pathId, conditions) => {
    if (!asyncStore.hidePathTimeline[pathId]) {
      asyncStore.hidePathTimeline[pathId] = [];
    }
    asyncStore.hidePathTimeline[pathId].push(...conditions);
  },
  pushLockPathTimeline: (pathId, lockData) => {
    if (!asyncStore.locksPathTimeline[pathId]) {
      asyncStore.locksPathTimeline[pathId] = [];
    }
    asyncStore.locksPathTimeline[pathId].push(lockData);
  },
};

export const parseTourLink = (link: string, slug?: string) => {
  const linkSlug = link.replace(/(.+\/)|(\?.+)/g, '');
  if (slug && linkSlug !== slug) return false;
  const res = new URLSearchParams(link.replace(/(.+\?)/, '?'));
  return { s: res.get('s'), x: Number(res.get('x')), y: Number(res.get('y')) };
};
export const checkIsFavourite = (products = [], product, mode = 0) => {
  if (mode === 0) {
    return products?.find((id) => id === product?.id);
  }
  return products?.find((id) => id === product?.eCommerceProductId);
};

export const capitalizeFirstLetter = (str: string) => {
  if (!str) return null;

  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const safeUrl = (url: string) => {
  if (!url.includes('http')) return `http://${url}`;
  return url;
};

let appearanceDelayTimeout = null;

export const handlePathDelay = (delay, setDelayedDisable) => {
  if (appearanceDelayTimeout) {
    clearTimeout(appearanceDelayTimeout);
    appearanceDelayTimeout = null;
  }
  if (delay) {
    setDelayedDisable(true);
    appearanceDelayTimeout = setTimeout(() => {
      setDelayedDisable(false);
    }, delay * 1000);
  } else {
    setDelayedDisable(false);
  }
};

export const isImage = (value) => /[^"]*?\.(jpg|png|bmp|wepb|webp|gif|jpeg|tif|tiff)/.test(value?.toLowerCase());

export const parsePathDestinationSweepData = (pathData: any) => {
  const res = {
    sweepUuid: pathData?.sweepUuid,
    isTourLink: pathData?.locationSrc === LocationSrc.tourLink,
    x: null,
    y: null,
  };
  try {
    if (res.isTourLink) {
      const parsedLink = parseTourLink(pathData.locationSmartLink);
      if (parsedLink && parsedLink?.s && parsedLink?.x && parsedLink?.y) {
        res.x = parsedLink.x;
        res.y = parsedLink.y;
        res.sweepUuid = parsedLink.s;
      }
    }
  } finally {
    return res;
  }
};
